import { TextTabScrollable } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';

import {
  BannerGroup,
  FilterParam,
  GrouppedComponentListMap,
  ShopInfo,
  TextCategoryList,
} from '@domains/storehome-common';

import { ScrollWrap, SelectedTextTabWrapper } from '../components/Main.styled';
import { useMainService } from '../services/useMainService';

export interface SelectedMainContainerProps {
  shop_info: ShopInfo;
  is_header_solid?: boolean;
  banner_group: BannerGroup | null;
  category_list: TextCategoryList[];
  is_preview?: boolean;
  renderSelectedMainBanner: (props: {
    shop_id: string;
    banner_group: BannerGroup | null;
    is_preview?: boolean;
  }) => React.ReactNode;
  renderSelectedShopInformation: (props: { shop_info: ShopInfo; is_cover_view: boolean }) => React.ReactNode;
  renderComponentList: (props: {
    type: 'store' | 'category' | 'zigzin-shipping';
    params: {
      shop_id: string;
      category_id?: string | null;
      check_button_item_ids?: string[];
      sub_filter_id_list?: string[];
    };
    components: GrouppedComponentListMap;
    is_fetching: boolean;
    error?: unknown;
    has_next_page?: boolean;
    is_selected?: boolean;
    onFetchNextPage: () => void;
    onParamsChange: (params: FilterParam) => void;
    refetch?: () => void;
  }) => React.ReactNode;
}

export const SelectedMainContainer = ({
  shop_info,
  is_header_solid,
  banner_group,
  category_list,
  is_preview,
  renderSelectedMainBanner,
  renderSelectedShopInformation,
  renderComponentList,
}: SelectedMainContainerProps) => {
  const {
    params,
    shop_id,
    applied_banner_group,
    categories,
    handleCategoryClick,
    component_list_props,
    exists_banner,
    onParamsChange,
    fetchNextPage,
  } = useMainService({ shop_info, banner_group, is_preview, category_list });
  return (
    <ScrollWrap>
      {renderSelectedMainBanner({ shop_id, banner_group: applied_banner_group, is_preview })}
      {renderSelectedShopInformation({ shop_info, is_cover_view: exists_banner })}
      <SelectedTextTabWrapper id='storehome-navigation-bar'>
        <TextTabScrollable
          defaultValue={null}
          items={categories}
          onChange={handleCategoryClick}
          hideBorderBottom
          impressionMode='once'
          fullWidth={false}
          size='large'
          backgroundColor={is_header_solid ? vars.color.backgroundSurface : 'transparent'}
          textColors={
            is_header_solid
              ? { default: vars.color.textTertiary, selected: vars.color.textPrimary }
              : { default: vars.color.staticWhite, selected: vars.color.staticWhite }
          }
        />
      </SelectedTextTabWrapper>
      {renderComponentList({
        type: 'store',
        params,
        ...component_list_props,
        onFetchNextPage: fetchNextPage,
        onParamsChange: onParamsChange,
      })}
    </ScrollWrap>
  );
};
